import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "product-content" }
const _hoisted_2 = { class: "main" }
const _hoisted_3 = { class: "product-box" }
const _hoisted_4 = { class: "left" }
const _hoisted_5 = { class: "right" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "img" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "name" }
const _hoisted_10 = { class: "look-more-button" }

import NavBar from '@/components/NavBar.vue';
import Footer from '@/components/Footer.vue';
import { UtilMethods } from '@/util/UtilMethods';
import Breadcrumb from '@/components/Breadcrumb.vue';
import { BreadType, Product } from '@/typeDefine/EntityType';
import ProductTypeSide from '@/components/ProductTypeSide.vue';
import HotSalesSide from '@/components/HotSalesSide.vue';
import { Action } from '@/typeDefine/CommonTypes';
import { BaseResponse, GetProductByTypeResponse, SearchProductByNameResponse } from '@/typeDefine/HttpResponseType';
import { Api } from '@/http/Api';
import { ResponseCode } from '@/http/ResponseCode';
import { onMounted, ref, Ref, watch } from 'vue';
import Pagination from '@/components/Pagination.vue';
import { Loading } from '@/util/Loading';
import { ConstantField } from '@/constant/ConstantField';
import { router } from '@/router';
import { useRoute } from 'vue-router';
import { GetProductByTypeRequest, SearchProductByNameRequest } from '@/typeDefine/HttpRequestType';

type SearchNameApiFunction = (param: SearchProductByNameRequest) => Promise<SearchProductByNameResponse>
type ByTypeApiFunction = (param: GetProductByTypeRequest) => Promise<GetProductByTypeResponse>


export default /*@__PURE__*/_defineComponent({
  __name: 'Product',
  setup(__props) {

const maxZIndex: string = UtilMethods.getDOMStyleFromCSS('--max-z-index')

const productTypeSideRef: Ref<InstanceType<typeof ProductTypeSide> | null> = ref(null)

const breadList: BreadType[] = [
    {
        text: 'index.navBar.product'
    }
]

const currentPage: Ref<number> = ref(1)
//页大小
const pageSize: Ref<number> = ref(10)
const totalPage: Ref<number> = ref(0)

//产品类型侧边栏是否默认选中
const isSelectProductType: Ref<boolean> = ref(true)

//当前选择的产品类别
const currentTypeId: Ref<string> = ref('')

//产品列表
const product: Ref<GetProductByTypeResponse['data']['product']> = ref([])

const route = useRoute()

onMounted(() => {
    isSelectProductType.value = typeof route.query.keyword === 'undefined'

    if (!isSelectProductType.value) {
        //用户搜索了产品
        requestProductBySearchName(route.query.keyword as string, currentPage.value)
    }
})

const request: Action<[SearchNameApiFunction | ByTypeApiFunction, any]> = async (api, param) => {
    Loading.instance.open('请稍后...')

    const response = await api(param)

    Loading.instance.close()

    UtilMethods.showMessageToast(response, false)

    if (response.code === ResponseCode.OK) {
        product.value = response.data.product
        totalPage.value = response.data.totalPage
    }
}

const requestProductBySearchName: Action<[string, number]> = async (searchName: string, startPage: number) => {

    await request(Api.instance.searchProductByName, {
        productName: searchName,
        startPage: startPage
    })
}

const requestProductByType: Action<[string, number]> = async (typeId: string, startPage: number) => {

    await request(Api.instance.getProductByType, {
        typeId,
        startPage: startPage
    })
}

//处理切换产品类型事件
const selectProductTypeHandler: Action<[string]> = async (typeId: string) => {

    currentTypeId.value = typeId
    requestProductByType(typeId, currentPage.value)

    if (!isSelectProductType.value) {
        router.replace({
            name: router.currentRoute.value.name
        })
    }
}

const onPageChange: Action<[number]> = (value: number) => {
    requestProductByType(currentTypeId.value, currentPage.value)
}

const gotoProductDetails: Action<[number]> = (id: number) => {
    router.push({
        name: 'productDetails',
        params: {
            id
        }
    })
}

//监听页面参数变化
watch(() => route.query.typeId,
    (value) => {
        isSelectProductType.value = true
        productTypeSideRef.value?.requestTypes()
    }, { deep: true })

watch(() => route.query.keyword,
    (value) => {
        if (value) {
            isSelectProductType.value = false
            currentPage.value = 1
            requestProductBySearchName(value as string, currentPage.value)
        }
    }, { deep: true })

return (_ctx: any,_cache: any) => {
  const _component_el_affix = _resolveComponent("el-affix")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_affix, { "z-index": _unref(maxZIndex) }, {
      default: _withCtx(() => [
        _createVNode(NavBar)
      ]),
      _: 1
    }, 8, ["z-index"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Breadcrumb, { "bread-list": breadList }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(ProductTypeSide, {
            ref_key: "productTypeSideRef",
            ref: productTypeSideRef,
            onSelectProductType: selectProductTypeHandler,
            "is-select": isSelectProductType.value
          }, null, 8, ["is-select"]),
          _createVNode(HotSalesSide)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_row, {
            gutter: 40,
            justify: product.value.length > 0 ? 'start' : 'center'
          }, {
            default: _withCtx(() => [
              (product.value.length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(product.value, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_col, {
                      span: 8,
                      key: item.id,
                      lg: 8,
                      md: 12,
                      sm: 24,
                      xs: 24
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("img", {
                              src: `${item.cover}`,
                              fit: "cover"
                            }, null, 8, _hoisted_8)
                          ]),
                          _createElementVNode("div", _hoisted_9, _toDisplayString(item.name), 1),
                          _createElementVNode("div", _hoisted_10, [
                            _createVNode(_component_el_button, {
                              size: "large",
                              onClick: ($event: any) => (gotoProductDetails(item.id))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('products.lookMoreText')), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                : (_openBlock(), _createBlock(_component_el_empty, {
                    key: 1,
                    "image-size": 200,
                    description: _ctx.$t('products.noProduct')
                  }, null, 8, ["description"]))
            ]),
            _: 1
          }, 8, ["justify"])
        ])
      ]),
      _createVNode(Pagination, {
        "current-page": currentPage.value,
        "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
        "page-size": pageSize.value,
        "total-page": totalPage.value,
        onCurrentPageChange: onPageChange,
        class: "page"
      }, null, 8, ["current-page", "page-size", "total-page"])
    ]),
    _createVNode(Footer)
  ]))
}
}

})